/**
 * Shape check for ids that get interpolated into SQL. Mixed-case on purpose
 * (legacy and factory ids); not an existence check.
 */
export const CUID_PATTERN = /^[a-zA-Z0-9]{20,30}$/;

export const isCuidLike = (value: unknown): value is string =>
  typeof value === "string" && CUID_PATTERN.test(value);
